import {ContractState} from './ContractState';
import {
  CANCEL_CONTRACTS_SUCCESS,
  DELETE_CONTRACTS_SUCCESS,
  GET_CONTRACTS_SUCCESS,
  ON_SELECT_CONTRACT,
  POST_CONTRACTS_SUCCESS,
  SharedContractActionType,
} from './SharedContractActions';

const initialState: ContractState = {
  data: [],
  selectedContract: null,
};

export const sharedContractReducer = (
  state: ContractState = initialState,
  action: SharedContractActionType,
): ContractState => {
  switch (action.type) {
    case GET_CONTRACTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    case ON_SELECT_CONTRACT:
      return {
        ...state,
        selectedContract: action.payload,
      };
    case POST_CONTRACTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    case DELETE_CONTRACTS_SUCCESS:
      return {
        ...state,
        data: state.data.filter(
          (contract) => contract.id !== action.payload.id,
        ),
        selectedContract:
          state.selectedContract?.id === action.payload.id
            ? null
            : state.selectedContract,
      };

    case CANCEL_CONTRACTS_SUCCESS:
      return {
        ...state,
        data: state.data.map((contract) =>
          contract.id === action.payload.id ? action.payload : contract,
        ),
        selectedContract:
          state.selectedContract?.id === action.payload.id
            ? action.payload
            : state.selectedContract,
      };
    default:
      return state;
  }
};
